import _ from 'underscore'

export const getClientsByFilters = (clients, search) =>
    _.sortBy(clients, (e) => e.name.toLowerCase()).filter((client) => {
        if (!search || (search && search === client._id))
            return client
    })


export const getSelectReportsOptions = (clients) => _.sortBy(clients.map((client) => ({ value: client._id, label: client.name, key: '_id' })), 'name')


// WEBPACK FOOTER //
// ./src/client/features/client/lib.js